import React from 'react';
import { motion } from 'framer-motion';
import baby_playing from '../../../assets/images/behavioral_therapy/baby_playing.jpg';
import heroImage from '../../../assets/images/behavioral_therapy/bg.jpg';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';

function ChildrenBenefit() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <div
      className="w-full  bg-cover bg-center relative z-20"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
        <div className="flex flex-col md:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-16">
          <div className="flex-1 flex justify-center lg:justify-end relative">
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : -300 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                className="rounded-3xl"
                src={baby_playing}
                alt="baby playing session for child in Wasilla, Alaska clinic"
              />
            </motion.div>
          </div>
          <div className="flex flex-1 flex-col gap-4 text-left text-white text-[18px] sm:text-[24px] md:text-[35px] font-bold">
            <p>
              <span className="">
                Young children may benefit from an evaluation and treatment if
                they:
              </span>
            </p>
            <ul className="text-[18px] lg:text-[22px] font-[500] text-white pl-4 space-y-2 list-disc">
              <li>
                Have frequent tantrums or are intensely irritable much of the
                time
              </li>
              <li>Often talk about fears or worries</li>
              <li>
                Complain about frequent stomachaches or headaches with no known
                medical cause
              </li>
              <li>
                Are in constant motion and cannot sit quietly (except when they
                are watching videos or playing videogames)
              </li>
              <li>
                Sleep too much or too little, have frequent nightmares, or seem
                sleepy during the day
              </li>
              <li>
                Are not interested in playing with other children or have
                difficulty making friends
              </li>
              <li>
                Struggle academically or have experienced a recent decline in
                grades
              </li>
              <li>
                Repeat actions or check things many times out of fear that
                something bad may happen.
              </li>
              <div className="mt-2">
                <Link
                  to="/contact"
                  className="inline-block border-2 mt-4 border-white w-full sm:w-fit px-4 hover:bg-primary hover:border-[#764D99] py-1 rounded-md text-white font-semibold text-lg xl:text-[18px] 3xl:text-[20px] transition-all duration-300 transform hover:scale-105 text-center"
                >
                  Schedule now
                </Link>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChildrenBenefit;
